<template>
  <basic-container>
    <div class="factoring-contract-detail">
      <div class="inner-con">
        <div class="project-title">
          <!-- <span v-if="Object.values(processDetail).length > 0">
            {{ processDetail.process.processDefinitionName }}
          </span> -->
          <span>
            {{ basicInfoData.contractName }}
          </span>

          <span
            class="serial_number"
            v-if="Object.values(processDetail).length > 0"
            @click="toBatch(processDetail.process.processInstanceId)"
            >(流水号: {{ processDetail.process.variables.serialNumber }})</span
          >
          <!-- <span
            class="serial_number"
            v-if="processDetailStop.process.processInstanceId"
            @click="toBatch(processDetailStop.process.processInstanceId, 1)"
            >(流水号:
            {{ processDetailStop.process.variables.serialNumber }})</span
          > -->
        </div>
        <div class="project-status">
          <div class="status-title">合同状态</div>
          <div
            class="status-content"
            :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]"
          >
            {{ auditStatusStr }}
          </div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="合同详情" name="first">
            <InfoContainer
              style="margin-top: 20px"
              :infoTitle="InfoContainerConfig['infoTitle']"
              :contentConfig="InfoContainerConfig['infoContent']"
            >
              <template slot="basicInfo">
                <CommonDetail
                  :configArray="
                    basicInfoData.stopFlowableId
                      ? [
                          ...formConfig['column'],
                          {
                            label: '附件',
                            prop: 'fileList',
                            slot: true,

                            span: 24,
                          },
                          {
                            label: '备注',
                            prop: 'stopRemark',
                            slot: true,
                            span: 24,
                          },
                        ]
                      : formConfig['column']
                  "
                  :initValue="basicInfoData"
                >
                  <template slot="expectPayDate" v-if="disabled">
                    <div>{{ basicInfoData.expectPayDate }}</div>
                  </template>
                  <template slot="contractNo" v-if="disabled">
                    <div>
                      {{
                        basicInfoData.contractNo
                          ? basicInfoData.contractNo
                          : "-"
                      }}
                    </div>
                  </template>
                  <template slot="custName" v-if="disabled">
                    <div>{{ basicInfoData.custName }}</div>
                  </template>
                  <template slot="stopRemark">
                    <div>{{ basicInfoData.stopRemark }}</div>
                  </template>
                  <template slot="fileList">
                    <div class="item-value">
                      <div class="">
                        <template v-for="(item, index) in fileList">
                          <div class="file_wrapper" :key="index">
                            <a
                              class="file_button"
                              target="_blank"
                              :href="
                                isWord(item.fileUrl)
                                  ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                                    item.fileUrl
                                  : item.fileUrl
                              "
                              type="text"
                              size="small"
                            >
                              {{ item.fileName }}
                            </a>
                            <i
                              @click="downLoadFile(item.id)"
                              class="el-icon-download del_icon"
                            ></i>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </CommonDetail>
              </template>
            </InfoContainer>

            <!-- 流程公共附件 -->
            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="$route.query.projectId || basicInfoData.projectId"
              :dynamicId="basicInfoData.projectId || $route.query.projectId"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
              :batchFileUpload="true"
            />
            <!-- 流程设计相关组件相关数据存储在workflow.js中 -->
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
              ref="auditInfo"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="isStartedProcess && auditFormData && auditFormData != {}"
              :formDetailData="auditFormData"
              :isEditable="
                processDetail.process ? processDetail.process.isEditable : false
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />

            <!-- 会签意见区 -->
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="
                processDetail.process ? Number(processDetail.process.taskNo) : 0
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />
            <!-- 流程记录  -->
            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length > 0"
              :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
              v-if="
                !isStartedProcess &&
                (basicInfoData.auditStatus == 0 ||
                  (basicInfoData.auditStatus != 0 &&
                    basicInfoData.flowableId != ''))
              "
              class="comment-container"
              style="margin-top: 20px"
              :infoTitle="commentBlockConfig['infoTitle']"
              :contentConfig="commentBlockConfig['infoContent']"
            >
              <template #comment>
                <CommentBlock
                  ref="commentBlock"
                  @fileChange="fileChange"
                  :id="id"
                />
              </template>
            </InfoContainer>
          </el-tab-pane>

          <!-- 投放详情 -->

          <el-tab-pane
            class="activelabel"
            v-if="basicInfoData.auditStatus > 1"
            label="投放列表"
            name="second"
          >
            <div class="informationxm">
              <div class="form_wrapper">
                <div class="form_header">
                  <div class="form_header_name">投放列表</div>
                  <div class="form_header_remarks"></div>
                </div>
                <avue-crud
                  :option="releaseConfig"
                  :data="dataLaunchlist"
                  @on-load="getprojectPlacementDetail"
                >
                  <template slot="id" slot-scope="scope">
                    <a
                      class="checkcontract"
                      @click="checkproject(scope.row.id)"
                    >
                      查看投放记录
                    </a>
                  </template>
                </avue-crud>
                <div></div>
              </div>
            </div>
          </el-tab-pane>

          <!-- 附件列表 -->
          <!-- <el-tab-pane
            class="activelabel"
            label="合同附件"
            name="third"
            v-if="
              basicInfoData.flowableId == '' && basicInfoData.auditStatus != 0
            "
          >
            <Accessory
              idname="合同管理"
              :upload="basicInfoData.auditStatus == 0"
              :projectid="id"
              fatername="转贷"
            />
          </el-tab-pane> -->

          <!-- 流程图（启动流程后显示） -->
          <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
            <template v-if="activeName == 'fourth'">
              <el-card shadow="never" style="margin-top: 5px">
                <wf-design
                  ref="bpmn"
                  style="height: 500px"
                  :options="bpmnOption"
                ></wf-design>
              </el-card>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="合同编号填写"
      :visible.sync="contractNoVisible"
      :modal-append-to-body="false"
      width="40%"
    >
      <el-form ref="contractNoForm" :model="contractNoForm" label-width="80px">
        <el-form-item
          label="合同编号"
          required
          prop="contractNo"
          :rules="[{ required: true, message: '合同编号不能为空' }]"
        >
          <el-input
            width="150px"
            v-model="contractNoForm.contractNo"
            placeholder="请填写合同编号"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitContractNo()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div
      class="bottom-container"
      v-if="!basicInfoData.flowableId && basicInfoData.auditStatus == 0"
    >
      <div class="button-container">
        <el-button type="primary" @click="saveProject(false)">保存</el-button>
        <el-button type="primary" plain @click="saveProject(true)"
          >提交审批</el-button
        >
      </div>
    </div>
    <div v-if="basicInfoData.flowableId && basicInfoData.isBatchAudit == 1">
      <div v-if="basicInfoData.auditStatus == 1">
        <div class="bottom-container">
          <div class="button-container">
            <el-button type="primary" v-if="isLast()" @click="flowNextBefore()"
              >合同编号</el-button
            >
            <el-button
              v-if="
                isStartedProcess &&
                processDetail.form &&
                processDetail.form.printFormKey.trim() != ''
              "
              type="info"
              plain
              @click="printForm"
              >打印</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <template v-else-if="isBottomLine()">
      <BottomLine
        ref="bottomLine"
        v-if="
          activeName == 'first' &&
          (basicInfoData.auditStatus == 0 ||
            (basicInfoData.auditStatus != 0 && basicInfoData.flowableId != ''))
        "
        :auditState="basicInfoData.auditStatus"
        :processDetail="processDetail"
        :isStartedProcess="isStartedProcess"
        @startProcess="saveProject(true)"
        @saveTask="saveTask"
        @saveProject="saveProject"
        @flowNext="flowNextBefore"
        @openPrintForm="goPrint"
        @refreshData="refreshData"
      />
    </template>
  </basic-container>
</template>
<script>
import Vue from "vue";
import { contractAddFormConfig, releaseConfig } from "./config.js";
import * as api from "@/api/zd/contract";
import { info } from "@/api/zd/project";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
import * as dictionaries from "@/api/zd/dictionaries";
// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessory";
import AccessoryFactor from "@/components/accessoriesother/accessoryFactor";

import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentStep from "@/components/workflowComponents/commentStep/commentStep";
import CommentTable from "@/components/workflowComponents/commentTable/commentTable";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine";
import workFlow from "@/mixins/workFlow";
import CommonDetail from "@/components/commonDetail/commonDetail";
import util from "@/mixins/util";
import { getTaskIdByProcessInsId, processInfo } from "@/api/workFlow/workFlow";
import { downLoadTemplate, downLoadTemplateGet } from "@/router/downLoadTem";
import { getSsoToken } from "@/api/workFlow/workFlow";

export default {
  name: "contractDetail",
  mixins: [workFlow, util],
  data() {
    return {
      id: "",
      sellerCustId: "",
      initParam: {},
      processKey: "process_zd_contract",
      activeName: "first",
      detailFormUrl: "/zd/contractmanage/contractDetailBatch",
      dataReady: false,
      isEditable: true,
      basicInfoData: {
        projectId: "",
      },
      isStartedProcess: false,
      formConfig: contractAddFormConfig(this.getMoney),
      releaseConfig: releaseConfig(this.getMoney),
      InfoContainerConfig: {
        infoTitle: "合同信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      dataLaunchlist: [],
      readOnly: false,
      loading: false,
      disabled: false,

      detailType: false,
      processDetailStop: {
        process: {
          variables: {},
        },
      },
      contractNoVisible: false,
      contractNoForm: {
        contractNo: null,
      },
    };
  },
  components: {
    InfoContainer,
    Accessory,
    AccessoryFactor,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
    CommonDetail,
  },
  computed: {
    ...mapGetters(["workFlowData", "userInfo"]),
    isBottomLine(){
      return function(){
        let isBottom=true
        if(!this.basicInfoData.flowableId&&this.$route.params.id != "-1"){
          return this.userInfo.user_id == this.basicInfoData.managerUser
        }
        return isBottom
      }
     
    },
    auditStatusStr() {
      let name = "";
      if (
        this.basicInfoData.auditStatus == 2 &&
        this.basicInfoData.auditStatusStop == 2
      ) {
        name = "合同终止";
      } else {
        name = this.basicInfoData.auditStatusStr;
      }

      return name;
    },
    isLast() {
      return function () {
        let flowData = this.flowData;

        if (flowData.length > 0) {
          if (
            flowData[flowData.length - 1].assignee == this.userInfo.user_id &&
            flowData[flowData.length - 1].historyActivityName == "综合管理部"
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
    },
  },
  watch: {
    "$route.params.id": {
      handler(newId, oldId) {
        this.id = newId;
        this.startContract();
      },
      deep: true,
    },
  },
  async mounted() {
    this.startContract();
  },
  methods: {
    // 打印表单
    async printForm() {
      // this.$emit('openPrintForm')
      let printFormKey = this.processDetail.form.printFormKey;
      // 获取ssoToken
      let res = await getSsoToken({});
      let ssoToken = res.data.data.ssoToken;
      let frontUrl = res.data.data.foreignUrl;

      let redirectId = this.$route.params.id;
      let flowableId = this.processDetail.process.processInstanceId;
      // 跳转打印地址 http://192.168.12.189:80
      let openUrl = "";
      if (redirectId.indexOf("-") > 0) {
        openUrl = `http://${frontUrl}/webroot/decision/view/report?viewlet=${printFormKey}&flowableId=${flowableId}&ssoToken=${ssoToken}`;
      } else {
        openUrl = `http://${frontUrl}/webroot/decision/view/report?viewlet=${printFormKey}&id=${redirectId}&ssoToken=${ssoToken}`;
      }
      // let openUrl = `${window.location.origin}/webroot/decision/view/report?viewlet=${printFormKey}&id=${redirectId}&ssoToken=${ssoToken}`
      window.open(openUrl);
    },

    async startContract() {
      if (this.$route.params.id && this.$route.params.id != "0") {
        this.id = this.$route.params.id;
        this.queryContractDetail();
      } else {
        this.getSuerveyDetail();
        this.id = await this.setNewId();
        this.getBasicConfigData();
      }
    },
    checkproject(id) {
      this.$router.push({ path: `/zd/placement/detail/${id}` });
    },
    getprojectPlacementDetail() {
      api.projectPlacementDetail({ id: this.$route.params.id }).then((res) => {
        this.dataLaunchlist = res.data.data;
      });
    },
    toBatch(processInstanceId, stopStatus) {
      this.$router.push({
        path: `/zd/contractmanage/contractDetailBatch/${processInstanceId}`,
        // query: {
        //   stopStatus,
        // },
      });
    },
    refreshData() {
      this.queryContractDetail();
    },
    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(
        "process_zd_contract"
      );
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(
        this.processDefinedId,
        "",
        true
      );
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId);
    },

    async getSuerveyDetail() {
      info({ id: this.$route.query.projectId })
        .then((res) => {
          this.basicInfoData = res.data.data;
          this.basicInfoData.auditStatusStr = "待提交";
          this.basicInfoData.auditStatus = 0;
          this.basicInfoData.projectId = this.$route.query.projectId;

          this.basicInfoData.contractName =
            this.basicInfoData.name + "转贷资金使用协议";
          this.basicInfoData.projectName = this.basicInfoData.name;
          delete this.basicInfoData.flowableId;
        })
        .catch((res) => {});
    },
    //通过名称获取菜单
    getFileMenuByName(fileMenuName, name, id) {
      dictionaries
        .getFileMenuByName({ fileMenuName })
        .then((res) => {
          this.findFileByOtherId(res.data.data.id, name, id);
        })
        .catch((res) => {});
    },
    findFileByOtherId(baFileMenuId, name, id) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => {
          this[name] = res.data.data;
        })
        .catch((res) => {});
    },

    async queryContractDetail() {
      let res = await api.contractinfo({
        id: this.id,
      });
      if (res.data.code == 200) {
        this.loading = false;
        let basicInfoData = res.data.data;

        // let dataList = [{ code: "wf_status", name: "auditStatus" }];
        // let dataSource = await this.dictionaryMap(dataList, basicInfoData);
        this.basicInfoData = basicInfoData;

        this.disabled = !(
          this.userInfo.user_id == this.basicInfoData.createUser &&
          this.basicInfoData.auditStatus == 0
        );

        this.getBasicConfigData();

        // 查询流程数据
        this.$store.commit("SET_WORKFLOW_STATE", {
          state: this.basicInfoData.auditStatus,
        });
        if (res.data.data && res.data.data.stopFlowableId) {
          this.getFileMenuByName(
            "转贷业务合同管理合同终止",
            "fileList",
            res.data.data.stopFlowableId
          );

          // this.isStartedProcess = true;
          // // 集成在workFlow.js中
          // let taskIdRes = await getTaskIdByProcessInsId({
          //   processId: res.data.data.stopFlowableId,
          // });

          // let processDetailRes = await processInfo({
          //   processInsId: res.data.data.stopFlowableId,
          //   taskId: taskIdRes.data.data,
          // });
          // if (processDetailRes.data.code == 200) {
          //   this.processDetailStop = processDetailRes.data.data;
          // }
        }

        if (res.data.data && res.data.data.flowableId) {
          this.isStartedProcess = true;
          // 集成在workFlow.js中
          await this.queryFlowData(res.data.data.flowableId);
        } else {
          // 未启动流程 查询第一个节点的文件上传权限
          this.processDefinedId = await this.userQueryProcessDefinedId(
            res.data.data.stopFlowableId
              ? "process_zd_contract"
              : "process_zd_contract"
          );
          this.permissionList = await this.queryTaskUploadDetail(
            this.processDefinedId,
            "",
            true
          );
          // 设置流程表单路径
          this.queryProcessFormDetail(this.processDefinedId);
        }
        let flowData = this.flowData;
        this.formConfig.column.filter((item) => {
          if (item.prop === "expectPayDate" || item.prop === "contractNo") {
            item.slot = !(
              this.userInfo.user_id == this.basicInfoData.createUser &&
              this.basicInfoData.auditStatus == 0
            );
          }
          // if (item.prop === "contractNo") {
          //   item.disabled = !(
          //     flowData[flowData.length - 1].assignee == this.userInfo.user_id &&
          //     this.basicInfoData.auditStatus == 1
          //   );
          // }
        });

        let presentFlow = this.flowData[this.flowData.length - 1];
        if (
          this.basicInfoData.auditStatus == 0 ||
          this.processDetail.flow[2].historyActivityId ==
            presentFlow.historyActivityId
        ) {
          this.columnEditChange(true);
        } else {
          this.columnEditChange(false);
        }
      }
    },
    columnEditChange(edit) {
      if (this.userInfo.user_id != this.basicInfoData.managerUser) edit = false;
      this.isEditable = edit;

      this.formConfig.column.filter((item) => {
        if (item.prop === "expectPayDate") {
          item.slot = !edit;
        }
      });
    },
    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    // 保存尽调数据
    async saveTask() {
      let taskId = this.processDetail.process.taskId;
      // 从vuex中获取
      let comment = this.workFlowData.opinionContent;
      // let attachmentList = this.workFlowData.attchmentList

      // 流程表单数据
      let customData = this.$refs.auditInfo.commentDetail;
      let formData = this.$refs.auditInfo.$data.formData;

      let variables = this.dealAuditForm(formData, customData);
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment;
      // variables[`attachment_${taskId}`] = attachmentList

      let saveRes = await this.flowSaveTask(variables);
      // 刷新数据
      this.saveTask = {
        comment: "",
        attachment: [],
      };
      this.queryContractDetail(this.id);
      this.$forceUpdate();
    },

    flowNextBefore() {
      let flowData = this.flowData;

      if (flowData.length > 0) {
        if (
          flowData[flowData.length - 1].historyActivityName == "综合管理部" &&
          flowData[flowData.length - 1].assignee == this.userInfo.user_id
        ) {
          this.contractNoForm = {
            contractNo: this.basicInfoData.contractNo,
          };
          if (this.$refs.contractNoForm) {
            this.$refs.contractNoForm.clearValidate();
          }
          this.contractNoVisible = true;
          //最后一步，综合管理员填写合同编号
        } else {
          this.flowNext();
        }
      } else {
        this.flowNext();
      }
    },
    submitContractNo() {
      this.$refs.contractNoForm.validate((vaild) => {
        if (vaild) {
          this.basicInfoData.contractNo = this.contractNoForm.contractNo;
          this.contractNoVisible = false;
          if (this.basicInfoData.isBatchAudit == 1) {
            this.submitForm(true);
          } else {
            this.flowNext(true);
          }
        }
      });
    },
    // 流程流转
    async flowNext(isLast) {
      let self = this;

      if (isLast && !this.contractNoForm.contractNo) {
        this.$message.error("请先输入合同编号");
        return;
      }

      let presentFlow = this.flowData[this.flowData.length - 1];
      if (
        this.processDetail.flow[2].historyActivityId ==
          presentFlow.historyActivityId ||
        isLast
      ) {
        this.submitForm();
      }

      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;

      // 流程表单数据
      let valid = this.$refs.auditInfo.validData();
      if (valid) {
        let customData = this.$refs.auditInfo.commentDetail;
        let formData = this.$refs.auditInfo.$data.formData;

        let variables = this.dealAuditForm(formData, customData);

        let res = await this.taskFlowNext(
          taskId,
          processInsId,
          this.workFlowData.attchmentList
            ? this.workFlowData.attchmentList
            : [],
          this.workFlowData.opinionContent
            ? this.workFlowData.opinionContent
            : "",
          variables
        );
        // 刷新数据
        this.getDetail();
        this.$forceUpdate();
      }
    },

    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id;
      this.basicInfoData.sellerCustName = data.custName;
    },

    saveProject(startProcess) {
      let self = this;
      // if (!this.basicInfoData.contractNo) {
      //   this.$message.error("请先输入合同编号");
      //   return;
      // }

      if (startProcess) {
        this.startProcess();
      } else {
        self.submitForm(true);
      }
    },

    async startProcess() {
      let redirectInfo = {
        url: this.detailFormUrl,
        id: this.id,
      };

      let params = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
        riskExposure: Number(this.basicInfoData.factoringCredit),
      };
      let processInsId = await this.startWorkFlowProcess(params);
      // this.basicInfoData.flowableId = processInsId;
      let redirectInfos = {
        url: "/zd/contractmanage/contractDetailBatch",
        id: processInsId,
      };
      let batchParams = {
        flowableId: processInsId,
        detailFormUrl: JSON.stringify(redirectInfos),
        fileMenuName: "合同管理",
        fileMenuUrlname: "转贷",
        ids: [this.id],
      };
      this.submitForm(false, batchParams);
    },

    async submitForm(delType, batchParams = {}) {
      let params = {
        ...this.basicInfoData,

        // id: this.id,
      };
      if (delType) {
        delete params.flowableId;
        delete params.id;
      }

      params.id = this.id;

      let res = await api.contractsubmit(params);
      if (res.data.code == 200) {
        // 刷新界面
        this.id = res.data.data;
        this.detailType = true;

        // 提交单个批量审批
        if (batchParams.flowableId) {
          await api.batchAudit(batchParams);
        }

        this.$router.push({
          path: `/zd/contractmanage/contractDetail/${res.data.data}`,
        });
        this.getDetail();
        this.$forceUpdate();
        this.$message({
          message: "修改成功",
          type: "success",
        });
      }
    },
    getDetail() {
      this.loading = true;
      this.queryContractDetail();
    },
    //下载附件
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this[name].splice(index, 1);
          this.form[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contract_name {
  font-size: 14px;
  font-weight: 400;
}

.factoring-contract-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;

  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    margin-bottom: 2px;
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }

    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }

    .project-status {
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }

      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }

  .comment-container {
    margin-top: 20px;

    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }

  .comment_container {
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    /deep/ .el-card__body {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .listTable {
      margin-top: 0px !important;
    }

    /deep/ .el-table {
      border: none;
    }

    /deep/ .el-table th {
      background-color: #fff;
      font-weight: 400;
    }
  }

  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    margin-bottom: 2px;
  }

  .color_0::before {
    background: #fec03d;
  }

  .color_1::before {
    background: #409eff;
  }

  .color_2::before {
    background: #51d351;
  }

  .color_3::before {
    background: #f56c6c;
  }

  .color_4::before {
    background: #f56c6c;
  }

  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }

  /deep/.el-tabs__item.is-active {
    background: none;
  }

  /deep/.el-tabs__header {
    margin: 0px;
  }

  /deep/ .avue-form__menu--center {
    display: none;
  }
}
.serial_number {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
/deep/ .informationxm {
  margin-top: 20px;
  .avue-crud__menu {
    display: none;
  }
}
/deep/ .avue-crud {
  width: 100%;
}
.bottom-container {
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
  .button-container {
    width: 78%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.el-icon-download {
  cursor: pointer;
}
</style>
